import { FormField, getErrors, LicensePlate } from '@maia/ui';
import { useFieldContext } from '../dynamic-form';
import { ComponentProps } from 'react';
import { formatLicensePlate, getSideCodeFromLicensePlate } from '@maia/utils';

type LicensePlateFieldProps = Omit<
  ComponentProps<typeof FormField>,
  'inputSlot'
>;

export function LicensePlateField(props: LicensePlateFieldProps) {
  const { ...rest } = props;
  const field = useFieldContext<string>();

  return (
    <FormField
      {...rest}
      error={getErrors(field)}
      inputSlot={
        <LicensePlate
          value={field.state.value}
          onChange={(event) => field.handleChange(event.target.value)}
          onBlur={(event) => {
            const input = event.target.value
              .toUpperCase()
              .replace(/[^a-zA-Z0-9]/g, '');

            const newValue = formatLicensePlate(
              input,
              getSideCodeFromLicensePlate(input),
            );
            field.handleBlur();
            field.handleChange(newValue);
          }}
        />
      }
    />
  );
}
